import React, { useMemo, useRef } from 'react'
import { Row } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'

import { ItemView, StyledColList } from 'components/SectionHandler'
import { DataTable } from 'components/DataTable'
import useDelItem from './useDelItem'
import { listCols } from './tableColumns'
import { NEW_RECORD_PATH } from 'config/consts'
import { ReactComponent as DelIcon } from 'media/icons/trashbin.svg'

const AutomationHandler = props => {
	const listDataRef = useRef([])
	const [t] = useTranslation()
	const delHandler = useDelItem(props)
	const { history, location, recordId } = props
	const getPath = newId => {
		const path = history?.location?.pathname
		return recordId ? location?.pathname.replace(recordId, newId) : `${path}/${newId}`
	}
	const itemData = useMemo(() => {
		if(!Array.isArray(listDataRef.current)) {
			return null
		}
		if(recordId === 'neue') {
			return {}
		}
		return listDataRef.current.find(({ id }) => id === recordId)
	}, [props.recordId, listDataRef.current])
	const handleNewRecord = newItemData => {
		const currList = listDataRef.current
		if(Array.isArray(currList)) {
			listDataRef.current = [...currList, newItemData]
		}
		history.push(getPath(newItemData.id))
	}
	const navToRecord = id => history.push(getPath(id))
	const onAddRecord = () => {
		const newPath = recordId ? location?.pathname.replace(recordId, NEW_RECORD_PATH) : `${history?.location?.pathname}/${NEW_RECORD_PATH}`
		return {
			onAddRecord: () => history.push(newPath)
		}
	}

	return(
		<Row style={{ height: '100%' }}>
			<StyledColList xs>
				<DataTable
					columns={listCols}
					remoteOptions={{
						query: props.sectionData?.listQuery,
						onCompleted: res => {
							listDataRef.current = res?.cashAssist?.listAutomationTaskServer || []
						}
					}}
					selectRow={{
						setSelectedRecord: navToRecord,
						selected: recordId
					}}
					{...onAddRecord()}
					rowMenu={[{
						func: delHandler,
						Icon: DelIcon
					}]}
					label={t('options_section.strings.server')}
					resizable={false}
					cssHeight
				/>
			</StyledColList>
			{itemData &&
				<ItemView
					key={recordId}
					{...props}
					skipQuery
					itemData={itemData}
					subsectionProps={{ handleNewRecord }}
				/>
			}
		</Row>
	)
}

export default AutomationHandler
